"use client";

import { Star } from "lucide-react";
import { useTranslations } from "next-intl";
import { GoogleStars } from "@/components/GoogleStars";
import { useExperimentVariant } from "@/hooks/useExperimentVariant";
import { site } from "@/lib/site";

// Footer rating row, driven by the `reviews-google-snippet` experiment. Gold
// Google stars are the control/SEO default; the "green" holdback variant swaps
// back to the old Trustpilot-style green stars once the flag loads on hydration.
export function FooterRating() {
  const t = useTranslations("Footer");
  const green = useExperimentVariant("reviews-google-snippet") === "green";

  return (
    <div className="mt-5 flex items-center gap-2.5">
      {green ? (
        <div className="flex">
          {Array.from({ length: site.rating.scale }).map((_, i) => (
            <Star key={i} className="size-4 fill-success text-success" />
          ))}
        </div>
      ) : (
        <GoogleStars starClassName="size-4" />
      )}
      <span className="text-sm text-slate">
        {t("reviews", { rating: site.rating.value, count: site.rating.count })}
      </span>
    </div>
  );
}
